import { stats } from "@/mocks/baogua";

export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[680px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20entertainment%20stage%20with%20spotlights%20and%20confetti%2C%20silhouette%20crowd%20watching%20live%20show%2C%20warm%20coral%20pink%20and%20amber%20neon%20glow%2C%20energy%20and%20excitement%2C%20cinematic%20concert%20atmosphere%2C%20no%20text&width=1800&height=1000&seq=hero-stage&orientation=landscape"
        alt="爆瓜台直播吃瓜现场舞台氛围"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/55 to-background-50"></div>

      <div className="relative mx-auto flex min-h-[680px] w-full max-w-7xl flex-col items-center justify-center px-4 pt-28 pb-16 text-center md:px-8">
        <div className="flex items-center gap-2 rounded-full border border-background-50/25 bg-foreground-950/30 px-4 py-1.5 backdrop-blur">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-400"></span>
          </span>
          <span className="text-sm font-medium text-background-100">1200+ 场吃瓜直播正在滚动的在线瓜场</span>
        </div>

        <h1 className="font-display mt-6 text-5xl leading-tight text-background-50 md:text-7xl">
          第一手瓜<br className="md:hidden" /> 随时开看
        </h1>
        <p className="mt-5 max-w-2xl text-base text-background-200/90 md:text-lg">
          爆瓜台直击现场，把明星绯闻、综艺名场面与剧组内幕第一时间搬上直播间。
          不用等明天，爆料到达端口即用，弹幕同步围观，一起吃遍滚动的在线瓜场。
        </p>

        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
          <button onClick={() => document.getElementById("live")?.scrollIntoView({ behavior: "smooth" })}
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-accent-500 px-7 py-3.5 text-base font-semibold text-background-50 hover:opacity-90 transition sm:w-auto">
            <i className="ri-live-line"></i> 点开直播频道
          </button>
          <button onClick={() => document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" })}
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-foreground-950/20 px-7 py-3.5 text-base font-semibold text-background-50 backdrop-blur hover:bg-foreground-950/40 transition sm:w-auto">
            <i className="ri-fire-line"></i> 先刷热搜瓜榜
          </button>
        </div>

        <div className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 md:gap-5">
          {stats.map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-50/15 bg-foreground-950/25 px-3 py-4 backdrop-blur">
              <div className="font-display text-2xl text-accent-300 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-background-200/85 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}